module.exports = __webpack_public_path__ + "static/media/Orchid.303d488f.jpg";